import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

// import { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// import NavTop from "../components/navTop";
import { HeaderBanner } from "../components/banners";
import NewsContent from "../UI/NewsContent";
import PageFooter from "../components/footer";
import { NavTopMain } from "../components/navTop";


import "../assets/css/news.css";

const apiUrl = process.env.REACT_APP_API_URL || "https://aed.mju.ac.th/api/arch/";

export default function ActivityNews() {
    const [newsInfo, setNewsInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [navMenuItem, setNavMenuItem] = useState([]);

    let ActApiUrl = "";
    const { code } = useParams();
    if (code) {
        // setApiUrl(apiUrl + code);
        // ActApiUrl = `${process.env.REACT_APP_ACT_API_URL}?code=${code}`;
        ActApiUrl = `https://aed.mju.ac.th/api/actdbms/v1/code/${code}`;
        console.log("ActApiUrl: ", ActApiUrl);
    }

    async function fetchNavMenuItem() {
        await axios
            .get(`${apiUrl}nav/index.json`)
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    }

    useEffect(() => {
        // const apiKey = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0";
        const headers = {
            "Content-Type": "application/json",
            // Authorization: apiKey,
        };

        // console.log("apiUrl: ", apiUrl);

        // news
        axios
            .get(ActApiUrl, headers)
            .then((res) => {
                if (res.data) {
                    setNewsInfo(res.data);
                    setIsLoading(false);
                } else {
                    setNewsInfo(null);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        fetchNavMenuItem();

        AOS.init();

        // eslint-disable-next-line
    }, []);

    return (
        <>
            <div id="contentHolder" style={{ marginBottom: "40px" }}>
                <HeaderBanner />
                {/* <div data-aos="fade-down" data-aos-duration="800">
                    <NavTop />
                </div> */}
                <div style={{ marginBottom: "50px" }}>
                    {navMenuItem && <NavTopMain navMenuItem={navMenuItem} />}
                </div>
                {isLoading ? (
                    <div>IS LOADING...</div>
                ) : (
                    <div style={{ zIndex: "1" }}>
                        {typeof newsInfo == "object" ? (
                            <>
                                {/* <h3>have data</h3> */}
                                {console.log("newsInfo: ", newsInfo)}
                                <NewsContent newsData={newsInfo} />
                            </>
                        ) : (
                            <div
                                style={{
                                    margin: "180px 10px",
                                    textAlign: "center",
                                    fontSize: "2.5rem",
                                    color: "#666666",
                                    textTransform: "uppercase",
                                }}
                            >
                                Sorry, Data no found.
                            </div>
                        )}
                    </div>
                )}
            </div>
            {navMenuItem && <PageFooter navMenuItem={navMenuItem} />}
        </>
    );
}
